export default "__VITE_ASSET__22a823de__"